import React from 'react';
import { Box, Skeleton, } from "../../imports/muiImport";


function GiftCardSectionSkeleton() {
    return (
        <Box
            maxWidth="xl"
            sx={{
                mt: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
                mb: { xs: "40px", sm: "45px", md: "50px", lg: "65px", xl: "65px" },
                width: "100%",
                height: "420px",
                boxShadow: 3,
                borderRadius: 3,
                p: {
                    xs: "2vh 1vw",
                    md: "2vh 1vw",
                    lg: "4vh 1vw",
                },
            }}
        >
            {/* Heading Title */}
            <Box sx={{ height: "65px", mb: 2 }}>
                <Skeleton animation="wave" sx={{ width: "460px", height: "37px", }} />
                <Skeleton animation="wave" sx={{ width: "350px", height: "26px", }} />
            </Box>
            <Box sx={{
                width: "100%",
                height: "300px",
                mt: 1,
                display: "flex",
                justifyContent: "Center",
                alignItems: "center"
            }}>

                {Array.from({ length: 7 }).map((_, index) => (
                    <Box
                        key={index * 1}
                        sx={{
                            mx: "8px",
                            width: "211px",
                            height: "255px",
                            boxShadow: 3,
                            borderRadius: 2,
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            width="100%"
                            height={115}
                            sx={{ borderRadius: 2, mb: 1 }}
                        />

                        <Box
                            sx={{
                                width: "183px",
                                height: "29px",
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <Skeleton animation="wave" sx={{ width: "130px" }} />
                            <Skeleton animation="wave" sx={{ width: "130px" }} />
                        </Box>
                        <Box
                            sx={{
                                width: "183px",
                                height: "50px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Skeleton animation="wave" sx={{ width: "160px", height: "58px" }} />
                            <Skeleton animation="wave" sx={{ width: "80px", height: "43px" }} />
                        </Box>
                        <Skeleton animation="wave" sx={{ width: "171px", height: "55px" }} />

                    </Box>
                ))}

            </Box>
        </Box>
    );
}

export default GiftCardSectionSkeleton